import React from 'react';

// Inline SVG to avoid extra HTTP request and enable faster rendering
const CreditLockIcon = React.memo(props => (
  <svg {...props} width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <g clipPath="url(#creditLockIconClip)">
      <g clipPath="url(#creditLockIconClipInner)">
        <path
          d="M10.75 9.33159C11.3412 9.05073 11.75 8.4481 11.75 7.75C11.75 6.7835 10.9665 6 10 6C9.0335 6 8.25 6.7835 8.25 7.75C8.25 8.4481 8.65876 9.05073 9.25 9.33159V12.25C9.25 12.6642 9.58579 13 10 13C10.4142 13 10.75 12.6642 10.75 12.25V9.33159Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.41478 0.0992866C9.79336 -0.0350486 10.2066 -0.0350487 10.5852 0.0992866L17.3352 2.49445C18.033 2.74203 18.5 3.40168 18.5 4.14309V9.00776L18.4998 9.01557C18.4268 12.5225 16.8285 15.08 15.0774 16.8285C13.3354 18.5678 11.4224 19.5296 10.631 19.8823C10.2091 20.0704 9.73404 20.0664 9.31631 19.875C8.52245 19.5114 6.58866 18.519 4.84384 16.7687C3.09085 15.0102 1.5 12.4543 1.5 8.99995V4.14309C1.5 3.40168 1.96705 2.74203 2.66478 2.49445L9.41478 0.0992866ZM10.0836 1.51293C10.0295 1.49374 9.97048 1.49374 9.9164 1.51293L3.1664 3.90809C3.06615 3.94366 3 4.03778 3 4.14309V8.99995C3 11.9486 4.34603 14.1446 5.90616 15.7097C7.47445 17.2829 9.22999 18.1856 9.94102 18.5113C9.96925 18.5243 9.99425 18.5239 10.0203 18.5123C10.724 18.1986 12.4551 17.3271 14.0175 15.767C15.5695 14.2174 16.9348 12.0119 17 8.99202V4.14309C17 4.03778 16.9338 3.94366 16.8336 3.90809L10.0836 1.51293Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="creditLockIconClip">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="creditLockIconClipInner">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
));

CreditLockIcon.displayName = 'CreditLockIcon';

export default CreditLockIcon;
